var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"test"}},[_c('el-button',{attrs:{"type":"primary"},on:{"click":_vm.info}},[_vm._v("添加")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }